import type { FaireProductEntity } from "../../entity_types/product";

export const p_r9c3buatq4: FaireProductEntity = {
  token: "p_r9c3buatq4",
  type: "product",
  name: "Mahj Jokers Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/20c46999f2bb7af1ab548ef3381994fddc850e454ab38e10ada5f1aab0130924.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f181e37d72b77adedce846ee86a0f592aa31c9845bdebf7450b11a7890c2350.jpeg",
    "https://cdn.faire.com/fastly/a57f141673a3f5578b0c7f30891174abe1df912912cc2650dba583e139670155.jpeg",
    "https://cdn.faire.com/fastly/e3648651267c89f9d960d4b53a25b30c60e747d281e5c1655fa1ad331e2e2a44.jpeg",
    "https://cdn.faire.com/fastly/b6bc57e6dc7cb9c124d340e3eb65c39fcc8eb3cf8db3bc5dc9045cdf436041c1.jpeg",
    "https://cdn.faire.com/fastly/9e3e29aac93e04b59cbc9ef48e9cef488a5873cef455ad9b5426357a025776e0.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:41.153Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
